import { analytics } from '@/shared/services/analytics'
import type { Router } from 'vue-router'
import { nextTick } from 'vue'

export function setupMiddleware(router: Router) {
  router.afterEach((to, _, failure) => {
    if (failure) return
    nextTick(() => {
      analytics.page(to.fullPath)
    })
  })
}
